import { Input, InputProps, theme } from 'antd'
import React, { useMemo } from 'react'
import { Toolbox } from '~/plugins/toolbox/shared'

const { useToken } = theme

type Props = InputProps & {
  delaySeconds?: number
  styleKey?: 'title' | 'title-2' | 'text-secondary'
}

export const InputDebounced: React.FC<Props> = ({
  id,
  delaySeconds = 0.5,
  styleKey,
  onChange = () => {},
  ...props
}) => {
  const token = useToken()

  const onChangeDebounced = useMemo(() => {
    return Toolbox.Utility.debounce(onChange, delaySeconds * 1000)
  }, [onChange])

  const style = useMemo(() => {
    switch (styleKey) {
      case 'title':
        return {
          fontWeight: 600,
          fontSize: '38px',
          lineHeight: 1.2105263157894737,
        }
      case 'title-2':
        return {
          fontWeight: 600,
          fontSize: '30px',
          lineHeight: 1.26,
        }
      case 'text-secondary':
        return {
          fontSize: '14px',
          lineHeight: 1.5714285714285714,
          color: token.token.colorTextTertiary,
        }
      default:
        return {}
    }
  }, [styleKey])

  return (
    <span id={id}>
      <Input
        onChange={delaySeconds === 0 ? onChange : onChangeDebounced}
        {...props}
        style={{ paddingLeft: 0, ...style, ...props.style }}
      />
    </span>
  )
}
